import { PayloadAction } from '@reduxjs/toolkit';

import { DesignData, DesignState } from 'editor/src/store/design/types';
import removeUnplaceableElements from 'editor/src/store/design/util/removeUnplaceableElements';

import { PluginName } from '../../plugins/types';
import { personalizationPluginNames } from '../../variants/operation/updateProductPersonalizationOperation';

const setDesignDataReducer = (state: DesignState, action: PayloadAction<DesignData | undefined>) => {
  // Every design entering the store passes here (load, variant switch, mockup
  // and format changes), so an element that can never be drawn or printed is
  // dropped at this one boundary.
  state.designData = action.payload && removeUnplaceableElements(action.payload).designData;
  // Per-spread add/remove flags come from preflight for every multipage product,
  // flat books (brochures) included, so we trust them on load exactly as we do
  // for spread books (photobooks). The structural page math in
  // updateDesignPagesUtil only runs on mutation (add/remove/reorder), where it
  // keeps flat designs off the spread-book cover/-4 math.
  state.globalPlugins =
    action.payload?.plugins?.filter((plugin) => personalizationPluginNames.has(plugin as PluginName)) || [];
};

export default setDesignDataReducer;
